require('./accountChequesMovements.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ utils
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { EmptyState } = require('commonsComponents/emptyState');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const AccountChequesMovementsTableRow = require('./accountChequesMovementsTableRow/accountChequesMovementsTableRow');
// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class AccountChequesMovements extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const {immAccount, requestCheques } = this.props;
        const accountId = immAccount.get('accountId');
        requestCheques(accountId);
    }

    builTableHeader() {
        const { immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        const headerTitle = formatText('accountCheques-chequebooks');
        const isInactiveAccount = immAccount.get('isInactiveAccount');
        const isCanceledAccount = !!immAccount.getIn(['filters', 'canceled']);

        return (
            <header className="account-cheques-movements__header">
                <div className="account-cheques-movements__title">
                    <OKBoxTitle value={headerTitle}/>
                </div>
                <div className="pull-right">
                    {
                        (!__CONTACT_CENTER__ || !isCanceledAccount) &&
                        <OKButton
                            leftIcon="icon-agregar"
                            modifier="ghost"
                            to={`/myprofile/accounts/${accountId}/new-chequebook`}
                            disabled={isInactiveAccount}
                        >
                            <FormattedText value="accountCheques-requestCounterfoil" format="firstUppercase" />
                        </OKButton>
                    }
                </div>
            </header>
        );
    }

    buildEmptyState(immAccount, message, iconType) {
        const accountAlias = immAccount.get('alias');
        const accountId = immAccount.get('accountId');
        const linkText = formatText('accountCheques-mainButton', [accountAlias]).toUpperCase();
        const linkUrl = `/myprofile/accounts/${accountId}/movements`

        return (
            <EmptyState
                primaryText={message}
                linkText={linkText}
                linkURL={linkUrl}
                iconType={iconType}
            />);
    }

    buildTable() {
        const { immCheques, immAccount } = this.props;
        const isCanceledAccount = !!immAccount.getIn(['filters', 'canceled'])

        return (
            <LastMovementsTable
                groupByDate={false}
                rowComponent={AccountChequesMovementsTableRow}
                immTransactionsByOrder={immCheques.get('byOrder')}
                immTransactionsById={immCheques.get('byId')}
                columnsCount={8}
                id={"account-cheques-movements"}
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                isCanceledAccount={__CONTACT_CENTER__ ? isCanceledAccount : undefined}
                language={language}
            >
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountCheques-status" />
                        </OKTableCell>
                        <OKTableCell className="account-cheques-movements__first-cell" asHeader={true}>
                            <FormattedText value="accountCheques-id" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountCheques-pending" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountCheques-payed" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountCheques-irregular" />
                        </OKTableCell>
                        <OKTableCell className="pull-right account-cheques-movements__cell-cancel-chequebook" asHeader={true} />
                    </OKTableRow>
                </thead>
            </LastMovementsTable>
        )
    }

    render() {
        const { immCheques, immAccount } = this.props;
        const headerContent = this.builTableHeader();
        let content;

        if (immCheques) {
            if (immCheques.get('error')) {
                const message = formatText('accountCheques-errorMessage');
                const iconType = "nointernet-banking";
                content = this.buildEmptyState(immAccount, message, iconType);
            } else if (immCheques.get('loading')) {
                content = <LoadingSection />;
            } else if (immCheques.get('byOrder').count() > 0) {
                content = this.buildTable();
            } else {
                const message = formatText('accountCheques-emptyMessage');
                const iconType = "search-banking";
                content = this.buildEmptyState(immAccount, message, iconType);
            }
        } else {
            content = <LoadingSection />;
        }

        return (
            <div className="account-cheques-movements__table">
                {headerContent}
                {content}
            </div>
        );
    }
}

AccountChequesMovements.propTypes = {
    immCheques: PropTypes.object,
    immAccount: PropTypes.object.isRequired,
    requestCheques: PropTypes.func.isRequired
};

module.exports = AccountChequesMovements;
